import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveOrganizationPayload } from "../types/organizationType";

export const getOrganizationList = createAsyncThunk("/organization/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/organizations?${query.toString()}`)).data;
  return response;
});

export const saveOrganization = createAsyncThunk("/organization/save", async (payload: SaveOrganizationPayload) => {
  const response = (await api.post("/organizations/action", payload)).data;
  return response;
});

export const deleteOrganization = createAsyncThunk("/organization/delete", async (id: number) => {
  const response = (await api.get(`/organizations/delete/${id}`)).data;
  return response;
});
